module.exports = __webpack_public_path__ + "static/img/OHSAS18001_Shulin.06422478.jpg";